import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import COLOURS from 'styles/export-vars.module.scss';

import './icon.scss';

export enum IconSizeConstraints {
  HEIGHT = 'HEIGHT',
  WIDTH = 'WIDTH'
}

interface IconProps extends Omit<FontAwesomeIconProps, 'size' | 'icon'> {
  className?: string;
  color?: string;
  size?: number;
  icon: IconProp | string;
  onlyConstrain?: IconSizeConstraints;
  button?: boolean;
  ariaHidden?: boolean;
}

function getIconDimension({
  sizePx,
  height,
  width
}: {
  sizePx: string;
  height?: string | number;
  width?: string | number;
}) {
  return {
    fontSize: sizePx,
    width: width || sizePx,
    height: height || sizePx
  };
}

const Icon = ({
  className = '',
  color,
  size = 20,
  icon,
  onlyConstrain,
  button: _button,
  ariaHidden: _ariaHidden = true,
  ...iconProps
}: IconProps) => {
  const sizePx = `${size}px`;
  const dimensions = getIconDimension({ sizePx, width: iconProps.width, height: iconProps.height });

  return (
    <FontAwesomeIcon
      className={cx('base-icon', className, {
        'base-icon--constrain-height': onlyConstrain === IconSizeConstraints.HEIGHT,
        'base-icon--constrain-width': onlyConstrain === IconSizeConstraints.WIDTH
      })}
      color={color ? COLOURS[color] : COLOURS.darkBlue}
      style={dimensions}
      icon={typeof icon === 'string' ? (['far', icon] as IconProp) : icon}
      {...iconProps}
    />
  );
};

export default Icon;
